import React from 'react';
import PropTypes from 'prop-types';

export const IconLiveChat = ({ className, color }) => (
  <svg className={className} width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.77148 0.614502C3.97453 0.614502 0.896484 3.69254 0.896484 7.4895V21.2395H21.5215C25.3184 21.2395 28.3965 18.1615 28.3965 14.3645V7.4895C28.3965 3.69254 25.3184 0.614502 21.5215 0.614502H7.77148ZM7.00785 8.63532C7.00785 8.00249 7.52086 7.48949 8.15368 7.48949H21.1398C21.7726 7.48949 22.2856 8.00249 22.2856 8.63532C22.2856 9.26815 21.7726 9.78115 21.1398 9.78115H8.15368C7.52086 9.78115 7.00785 9.26815 7.00785 8.63532ZM7.00785 13.2188C7.00785 12.586 7.52086 12.073 8.15368 12.073H17.3204C17.9532 12.073 18.4662 12.586 18.4662 13.2188C18.4662 13.8517 17.9532 14.3647 17.3204 14.3647H8.15368C7.52086 14.3647 7.00785 13.8517 7.00785 13.2188Z" fill={color} />
  </svg>
);

IconLiveChat.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

IconLiveChat.defaultProps = {
  className: null,
  color: 'black',
};
